import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// TODO: Replace the following with your app's Firebase project configuration
// See: https://firebase.google.com/docs/web/learn-more#config-object

/*const firebaseConfig = {
    apiKey: "YOUR_API_KEY",
    authDomain: "YOUR_PROJECT_ID.firebaseapp.com",
    projectId: "YOUR_PROJECT_ID",
    storageBucket: "YOUR_PROJECT_ID.appspot.com",
    messagingSenderId: "YOUR_MESSAGING_SENDER_ID",
    appId: "YOUR_APP_ID"
};*/

const firebaseConfig = {
    apiKey: "AIzaSyBkUMZcAsEBZerbSOBtqfKwLbnd3RN_xZg",
    authDomain: "carsmarket-a43dc.firebaseapp.com",
    projectId: "carsmarket-a43dc",
    storageBucket: "carsmarket-a43dc.appspot.com",
    messagingSenderId: "733090336108",
    appId: "1:733090336108:web:06ad6b9fab8710a0dc7749",
    measurementId: "G-939676WY9L"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize services
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

export default app;
